<template>
  <v-data-table
    :headers="headers"
    :items="campaigns"
    :search="search"
    class="elevation-1"
    @click:row="onUserClick"
  >
    <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y v-if="allowEditing">
            <template
            v-slot:activator="{on, attrs}">
                <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                dark>
                    <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click="action('edit', item)">Edit</v-list-item>
                <v-list-item @click="action('delete', item)">Delete</v-list-item>
            </v-list>
        </v-menu>
    </template>
  </v-data-table>
</template>
<script>
  export default {
    name: "CampaignList",
    props: [
      'search'
    ],
    data () {
      return {
        headers: [
          { text: 'Name', value: 'title' },
          /* { text: 'Created', value: 'created' },
          { text: 'Created by', value: 'createdBy' }, */
          { text: 'Start date', value: 'schedule.publish' },
          { text: 'End date', value: 'schedule.expire' },
          { text: 'Status', value: 'status' },
          { text: '', value: 'actions' },
        ],
      }
    },
    mounted(){
      this.$store.dispatch("dispatchGetCampaigns");
    },
    computed: {
      campaigns(){
        return this.$store.state.campaigns;
      },
      allowEditing(){
        // Allow editing for superadmins
        let currentRoles = this.$store.state.userRoles.inherits;
        return currentRoles.includes("superadmin") ? true : false;
      },
    },
    methods: {
      onUserClick(campaign){
          console.log(campaign);
          this.$emit('selectCampaign', campaign);
      },
      action(action, campaign){
        if(action == 'edit'){
          this.$emit('selectCampaign', campaign);
          this.$emit('showDialog');
        }
        if(action == 'delete'){
          this.$emit('deleteCampaign', campaign.id);
        }
      }
    }
  }
</script>
<style scoped>
    .v-data-table{
        width: 100%;
    }
</style>